import { Link, Text } from '@fluentui/react'
import { intersectionWith, sumBy } from 'lodash'
import { useDomainStore } from '../../../../../../../../features/Domain/store/domain'
import { USDCell } from '../../../../../../../../features/Lists/core/components/USDCell'
import { IEnrichedCreditEvent } from './CreditEvent'
import { RecipientHoverCard } from './RecipientHoverCard'

export const PayoutCell: React.FC<{
  creditEvent: IEnrichedCreditEvent
}> = ({ creditEvent }) => {
  const { rep, recipients, event } = creditEvent
  const {
    selectedAdvisorRepIds,
    accountRepsWithSplitVisibilityLookup,
    selectedAdvisorRepIdsLookup
  } = useDomainStore()

  const accountRepWithSplitVisibility =
    accountRepsWithSplitVisibilityLookup[rep?.repId || '']

  const { userHasAccessToSplits, userIsMemberOfRep, personalRepsInSplit } =
    accountRepWithSplitVisibility || {}
  if (!userHasAccessToSplits && !userIsMemberOfRep) {
    return <Text>--</Text>
  }

  const selectedRecipients = recipients?.filter((recipient) =>
    selectedAdvisorRepIds?.includes(recipient.recipientId || '')
  )

  const total = selectedRecipients?.length
    ? sumBy(selectedRecipients, ({ grossPayout = 0 }) => grossPayout)
    : selectedAdvisorRepIds?.length
    ? undefined
    : event?.grossPayout

  const hoverRecipients = userHasAccessToSplits
    ? recipients
    : intersectionWith(
        recipients,
        personalRepsInSplit || [],
        (a, b) => a.recipientId === b.id
      )

  return hoverRecipients?.length && total !== undefined ? (
    <RecipientHoverCard
      recipients={hoverRecipients}
      type={'grossPayout'}
      selectedLookup={selectedAdvisorRepIdsLookup}
    >
      <Link>
        <USDCell value={total} />
      </Link>
    </RecipientHoverCard>
  ) : (
    <Text>--</Text>
  )
}
